import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { CurrentUser } from '../models/currentUser.model';
import { MenuService } from '../services/menu.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  currentUser:CurrentUser;
  constructor(
    private userService:UserService,
    private menuService:MenuService
  ) { }

  ngOnInit() {
    if(this.userService.isLoggedIn()){
      this.userService.currentUser().subscribe((user:any)=>{
        this.currentUser = user;
      });  
    }
  }

}
